import React, { useRef, useState, useEffect } from "react";

import {
  CAvatar,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CButton,
  CFormSelect,
  CFormLabel,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPencil, cilPlus } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import {
  getReportList,
  getReportLogs,
  updateReportStatus,
} from "src/services/report.services";
import CommentModal from "src/components/CommentModal/CommentModal";
import ImageModal from "src/components/ImageModal/ImageModal";
import { getActiveCountryList } from "src/services/country.services";
import Select from "react-select";
import ReactSelect from "react-select";
import TableColumnSortIcon from "src/components/Sort/TableColumnSortIcon";
import useTableSort from "src/__custom_hook/useTableSort";
import { useMutation, useQuery } from "@tanstack/react-query";
import ReportHistoryModal from "src/components/ReportHistoryModal/ReportHistoryModal";

const ReportIssueManagementTable = () => {
  const { sortConfig, setSortConfig, handleClickColumnSort } = useTableSort();
  const [visibleCommentModal, setVisibleCommentModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [userInfo, setUserInfo] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const [selectedId, setSelectedId] = useState(null);
  const [previousStatus, setPreviousStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [modalErrorText, setModalErrorText] = useState("");
  const [reportComment, setReportComment] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [visibleImageModal, setVisibleImageModal] = useState(false);
  const [reportSelectedStatus, setReportSelectedStatus] = useState("");
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [statuses, setStatuses] = useState({});

  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );

  const ReportLogsMutation = useMutation({
    mutationKey: ["get-report-logs"],
    mutationFn: (id) => getReportLogs(id),
    onMutate: () => {
      toast.loading("Getting logs...");
    },
    onSuccess: (res) => {
      toast.dismiss();
      const logs = res.logs;
      setHistoryData(logs);
    },
    onError: (error) => {
      console.log(error);
      toast.dismiss();
      toast.error("Failed to get logs");
    },
  });

  const getReportItem = (page, status = null, country = null) => {
    setIsLoading(true);
    const params = {
      limit,
      page,
    };
    if (status) params.status = status;
    if (country) params.country = country;
    if (sortConfig) {
      params.sort = sortConfig
        .map((config) => `${config.key}:${config.direction}`)
        .join(",");
    }

    getReportList(params)
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  //get all active countries
  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1, status: true })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountryOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleCountryChange = (selectedOption) => {
    setCurrentPage(1);
    if (selectedOption) {
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
    setReportSelectedStatus("");
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    console.log(reportSelectedStatus);
    if (reportSelectedStatus) {
      getReportItem(newPage, reportSelectedStatus);
    } else if (selectedCountry && reportSelectedStatus) {
      getReportItem(newPage, reportSelectedStatus, selectedCountry.value);
    } else {
      getReportItem(newPage);
    }
  };

  const handleChange = (e, id) => {
    const newValue = e.target.value;
    if (!newValue) return;
    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      [id]: newValue,
    }));
    handleComment(newValue, id);
  };

  const handleComment = (value, id) => {
    console.log(value, id);
    setVisibleCommentModal(true);
    setSelectedId(id);
    const newData = data;

    const objectIndex = newData.findIndex((x) => x._id == id);
    setPreviousStatus(newData[objectIndex].status);
    setReportComment(newData[objectIndex].comment);
    setSelectedStatus(value);

    newData[objectIndex].status = value;
    setData(newData);
  };

  const handleReportComment = (event) => {
    const value = event.target.value;
    const trimmedValue = value.trim();

    // Check for empty comment after trimming
    if (!trimmedValue) {
      setReportComment("");
      setModalErrorText("Please write something in the comment box!");
      return;
    }

    setReportComment(value);
    setModalErrorText("");
  };

  const handleImageModal = (image) => {
    setSelectedImage(image);
    setVisibleImageModal(true);
  };

  const handleConfirm = (value) => {
    if (value == "confirm") {
      if (!reportComment) {
        setModalErrorText("Please write something on comment box!");
      } else {
        setVisibleCommentModal(false);
        const data = {
          status: selectedStatus,
          comment: reportComment,
        };
        toast
          .promise(
            updateReportStatus(data, selectedId),
            {
              loading: "Loading",
              success: "Report Status updated succesfully",
              error: (err) => {
                console.log(err);
                return "Something went wrong.";
              },
            },
            {
              id: "report-status",
            }
          )
          .then(async (response) => {
            setReportComment("");
            getReportItem(currentPage);
          })
          .catch((error) => console.error(error));
      }
    } else {
      const newData = data;
      const objectIndex = newData.findIndex((x) => x._id == selectedId);
      newData[objectIndex].status = previousStatus;
      setData(newData);
      setVisibleCommentModal(false);
    }
  };

  const handleChangeStatus = async (value) => {
    setCurrentPage(1);
    setReportSelectedStatus(value);
  };

  const onClickHistory = (id) => {
    setSelectedId(id);
    setShowHistoryModal(id);
    ReportLogsMutation.mutate(id);
  };
  const closeHistoryModal = () => {
    setSelectedId(null);
    setHistoryData([]);
    setShowHistoryModal(false);
  };

  useEffect(() => {
    if (data.length > 0) {
      const initialStatuses = data.reduce((acc, item) => {
        acc[item._id] = item.status;
        return acc;
      }, {});
      setStatuses(initialStatuses);
    }
  }, [data]);

  useEffect(() => {
    if (sortConfig.length > 0) {
      setCurrentPage(1);
      if (reportSelectedStatus) {
        getReportItem(1, reportSelectedStatus);
      } else if (selectedCountry && reportSelectedStatus) {
        getReportItem(1, reportSelectedStatus, selectedCountry.value);
      } else {
        getReportItem(1);
      }
    }
  }, [sortConfig]);

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") {
      if (selectedCountry) {
        getReportItem(currentPage, reportSelectedStatus, selectedCountry.value);
      } else {
        getReportItem(currentPage, reportSelectedStatus);
      }
    } else {
      if (reportSelectedStatus) {
        getReportItem(currentPage, reportSelectedStatus);
      } else {
        getReportItem(currentPage);
      }
    }
  }, [selectedCountry, reportSelectedStatus]);

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") {
      getActiveCountries();
    }
  }, []);

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Reported Issues - Total: {count}
              </h4>
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              <CRow className="mb-1 justify-content-end">
                {userInfo?.userType === "superAdmin" && (
                  <CCol sm={5}>
                    <Select
                      value={selectedCountry}
                      onChange={handleCountryChange}
                      options={countryOptions}
                      isClearable={true}
                      placeholder="Select Country"
                    />
                  </CCol>
                )}
                <CCol
                  sm={userInfo?.userType === "superAdmin" ? 4 : 6}
                  className="d-flex gap-3"
                >
                  <CFormSelect
                    value={reportSelectedStatus}
                    id={"priority"}
                    onChange={(e) => handleChangeStatus(e.target.value)}
                    style={{ width: "100%" }}
                  >
                    <option value="">All</option>
                    <option value="pending">Pending</option>
                    <option value="inProgress">In Progress</option>
                    <option value="solved">Solved</option>
                    <option value="cancelled">Cancelled</option>
                  </CFormSelect>

                  {/* <Link to="/create-report-issue" className="w-100">
                    <CButton>
                      <CIcon icon={cilPlus} />
                      &nbsp; Create
                    </CButton>
                  </Link> */}
                </CCol>
                <CCol
                  sm={userInfo?.userType === "superAdmin" ? 3 : 6}
                  className="float-end"
                >
                  <Link to="/create-report-issue" className="w-100">
                    <CButton className="w-100">
                      <CIcon icon={cilPlus} />
                      &nbsp; Create
                    </CButton>
                  </Link>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <br />
          <CTable
            align="middle"
            className="mb-0 border text-center"
            hover
            responsive
          >
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  Status
                </CTableHeaderCell>
                {userInfo &&
                ["admin", "superAdmin"].includes(userInfo?.userType) ? (
                  <CTableHeaderCell className="text-center">
                    Action
                  </CTableHeaderCell>
                ) : (
                  ""
                )}
                <CTableHeaderCell className="text-center">
                  History
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("title")}
                  style={{ cursor: "pointer" }}
                >
                  Title{" "}
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "title" }} />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Description
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Uploaded File
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("comment")}
                  style={{ cursor: "pointer" }}
                >
                  Comment{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "comment" }}
                  />
                </CTableHeaderCell>
                {userInfo && userInfo.userType == "admin" ? (
                  <CTableHeaderCell
                    className="text-center"
                    onClick={() => handleClickColumnSort("createdBy")}
                    style={{ cursor: "pointer" }}
                  >
                    Created By{" "}
                    <TableColumnSortIcon
                      {...{ sortConfig, dataKey: "createdBy" }}
                    />
                  </CTableHeaderCell>
                ) : (
                  ""
                )}

                {/*<CTableHeaderCell>User Type</CTableHeaderCell>
                <CTableHeaderCell>Action</CTableHeaderCell> */}
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="10">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="8">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell className="text-capitalize">
                      {item.status}
                    </CTableDataCell>

                    {userInfo &&
                    ["admin", "superAdmin"].includes(userInfo?.userType) ? (
                      <CTableDataCell>
                        <CCol xs={10}>
                          <CFormSelect
                            size="sm"
                            id={"priority" + item._id}
                            value={statuses[item._id] || ""}
                            disabled={item.status == "solved"}
                            onChange={(e) => handleChange(e, item._id)}
                          >
                            <option value="">Choose Action</option>
                            <option value="inProgress">In Progress</option>
                            <option value="solved">Solved</option>
                            <option value="cancelled">Cancelled</option>
                          </CFormSelect>
                        </CCol>
                      </CTableDataCell>
                    ) : (
                      ""
                    )}
                    <CTableDataCell className="text-capitalize">
                      <CButton
                        size="sm"
                        onClick={() => onClickHistory(item._id)}
                      >
                        History
                      </CButton>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CAvatar
                        size="md"
                        src={
                          item.createdBy.avatar
                            ? item.createdBy.avatar
                            : demoAvatar
                        }
                      />
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      <div>{item.title}</div>
                    </CTableDataCell>
                    <CTableDataCell style={{ width: "20%" }}>
                      {item.description}
                    </CTableDataCell>

                    <CTableDataCell>
                      {item.image ? (
                        <img
                          src={item.image}
                          width="50px"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleImageModal(item.image);
                          }}
                        />
                      ) : (
                        "N/A"
                      )}
                    </CTableDataCell>
                    <CTableDataCell>{item.comment}</CTableDataCell>
                    {userInfo && userInfo.userType == "admin" ? (
                      <CTableHeaderCell className="text-capitalize">
                        {item.createdBy.firstName +
                          " " +
                          item.createdBy.lastName}
                      </CTableHeaderCell>
                    ) : (
                      ""
                    )}
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <ReportHistoryModal
        visible={showHistoryModal && historyData.length}
        onClose={closeHistoryModal}
        data={historyData}
      />
      <CommentModal
        visible={visibleCommentModal}
        setVisibleCommentModal={setVisibleCommentModal}
        onConfirm={handleConfirm}
        errorText={modalErrorText}
        handleReportComment={handleReportComment}
        reportComment={reportComment}
      />
      <ImageModal
        visible={visibleImageModal}
        setVisibleImageModal={setVisibleImageModal}
        image={selectedImage}
        // addToast={addToast}
      />
    </>
  );
};

export default ReportIssueManagementTable;
